/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-fragments */
import React from "react";
import differenceWith from "lodash-es/differenceWith";
import isEqual from "lodash-es/isEqual";
import { components } from "react-select";

import { isFunction, isObject, isString } from "../../lib/utils";
import Bouncer from "../bouncer/bouncer";
import Tooltip from "../tooltip/tooltip";
import Button from "../button/button";
import Label from "../label/label";

const DefaultLoaderComponent = () => {
  return <Bouncer />;
};

const DefaultOptionComponent = optionProps => {
  const { tooltip = {} } = optionProps.data;
  const { text } = tooltip;
  const tooltipContent = isFunction(text) ? text(optionProps.data) : text;
  return (
    <components.Option {...optionProps}>
      {tooltipContent ? (
        <Tooltip {...tooltip} text={tooltipContent}>
          <span>{optionProps.data.label}</span>
        </Tooltip>
      ) : (
        optionProps.data.label
      )}
    </components.Option>
  );
};

const SelectDeselectMenuList = props => {
  const { selectProps, options: allOptions = [], children } = props;
  const {
    userProps: { onChange, validationProps, name: fieldName }
  } = selectProps;
  const enabledOptions = allOptions.filter(opt => !opt.isDisabled);
  const totalOptions = allOptions.length;
  const selectedOptions = selectProps.value || [];
  const difference = differenceWith(allOptions, selectedOptions, isEqual);
  const isAllSelected =
    differenceWith(enabledOptions, selectedOptions, isEqual).length === 0;
  const totalSelected = Math.max(allOptions.length - difference.length, 0);

  return (
    <React.Fragment>
      <components.MenuList {...props}>{children}</components.MenuList>
      <div className="oui-select-footer-container oui-select-deselect-all-footer">
        <Button
          className="oui-select-footer-button-link"
          type="link"
          disabled={allOptions.length === 0}
          label={
            !isAllSelected || allOptions.length === 0
              ? "Select All"
              : "Deselect All"
          }
          onClick={() => {
            let selectVals = [];
            if (isAllSelected) {
              selectVals = differenceWith(
                selectedOptions,
                allOptions,
                isEqual
              ).filter(option => !option.isDisabled);
            } else {
              selectVals = [...selectedOptions, ...difference].filter(
                option => !option.isDisabled
              );
            }

            onChange(selectVals);

            if (validationProps && validationProps.setFieldValue && fieldName) {
              validationProps.setFieldValue(fieldName, selectVals, true);
            }
          }}
        />
        <div className="oui-d-flex oui-align-items-center oui-footer-subtext">
          <Label className="oui-m-0" text={`${totalOptions} found`} />
          <Label
            className="oui-m-0 oui-ml-3 oui-footer-subtext"
            text={`${totalSelected} selected`}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

const OnlySelectAllMenuList = props => {
  const { selectProps, children } = props;
  const {
    internalRef,
    userProps: {
      selectAllButtonText,
      selectAllOptionDisabled,
      selectAllOptionDisabledTooltip,
      selectAllOption,
      footerRenderer,
      onChange,
      validationProps,
      name: fieldName,
      isMulti
    }
  } = selectProps;

  const selectAllText = selectAllButtonText || "Select All";
  const isFooterRequired = isFunction(footerRenderer);
  const isSelectAllRequired =
    isObject(selectAllOption) &&
    selectAllOption.label &&
    selectAllOption.value &&
    isMulti === true;

  return (
    <React.Fragment>
      <components.MenuList {...props}>{children}</components.MenuList>
      <div
        className={`oui-select-footer-container ${
          !isFooterRequired && isSelectAllRequired
            ? "oui-select-only-generic-all"
            : ""
        }`}
      >
        {isFooterRequired ? (
          <div className="oui-select-custom-footer">{footerRenderer()}</div>
        ) : null}

        {isSelectAllRequired ? (
          <div className="oui-select-generic-all-link">
            <Tooltip
              text={selectAllOptionDisabledTooltip}
              showToolTip={
                selectAllOptionDisabled === true &&
                isString(selectAllOptionDisabledTooltip)
              }
            >
              <span>
                <Button
                  className="oui-select-footer-button-link"
                  disabled={selectAllOptionDisabled}
                  type="link"
                  label={selectAllText}
                  onClick={() => {
                    onChange([selectAllOption]);

                    if (internalRef.current) {
                      // Need to focus again to maintain user experience
                      internalRef.current.blur();
                      internalRef.current.focus();
                    }

                    if (
                      validationProps &&
                      validationProps.setFieldValue &&
                      fieldName
                    ) {
                      validationProps.setFieldValue(
                        fieldName,
                        [selectAllOption],
                        true
                      );
                    }
                  }}
                />
              </span>
            </Tooltip>
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
};

const HiddenDropdownIndicator = () => null;

const HiddenDropdownSeparator = () => null;

export {
  DefaultLoaderComponent,
  DefaultOptionComponent,
  HiddenDropdownIndicator,
  HiddenDropdownSeparator,
  SelectDeselectMenuList,
  OnlySelectAllMenuList
};
